import { doGet, doPut } from "../base";

const URL = "/user_auth/pharmacies";

export const fetchPharmacies = async ({ pharmacyId }) => {
    let url = URL;
    if (pharmacyId) url = url + `/${pharmacyId}`

    return await doGet(url).catch((error) => {
        throw error;
    });
};

export const updateSettings = async ({ pharmacyId, payload }) => {
    const url = URL + `/${pharmacyId}/settings`

    return await doPut(payload, url).catch((error) => {
        throw error;
    });
};
